module.exports = __webpack_public_path__ + "img/desc_bottom_cc3623.c7ab8e53.png";